export default "__VITE_ASSET__541b2fd8__"